export default [
  {
    service: 'Emergency Room',
    resultsQty: 1,
    closestLocation: {
      isGoogle: false,
      hthId: 0,
      network: null,
      isGEM: true,
      name: 'Advocate Good Samaritan Hospital',
      originalName: 'Advocate Good Samaritan Hospital',
      translated: false,
      type: 'Organization',
      gender: '',
      service: 'Emergency Room',
      longitude: -88.008362,
      latitude: 41.818356,
      line_1: '3815 HIGHLAND AVENUE',
      line_2: '',
      city: 'DOWNERS GROVE',
      province: 'ILLINOIS',
      country: 'UNITED STATES',
      zip: '605151500',
      gemRanking: 1,
      googlePlaceId: 'ChIJH0a4ZQFODogRxuiuOHTiJ1M',
      distance: 11.906,
      timeInTraffic: '15 mins',
      isPediatric: 0,
      distanceUnit: 'km',
      phone: '(630) 275-5900',
      fax: null,
      email: null,
      partyId: 202453,
      locationId: 9659563,
      isNetworkProvider: false,
      providerIdType: null,
      providerId: null,
      hoursPerDay: [
        'Sunday: Open 24 hours',
        'Monday: Open 24 hours',
        'Tuesday: Open 24 hours',
        'Wednesday: Open 24 hours',
        'Thursday: Open 24 hours',
        'Friday: Open 24 hours',
        'Saturday: Open 24 hours'
      ],
      placeResult: {
        result: {
          address_components: [
            {
              long_name: '3815',
              short_name: '3815',
              types: [
                'street_number'
              ]
            },
            {
              long_name: 'Highland Avenue',
              short_name: 'Highland Ave',
              types: [
                'route'
              ]
            },
            {
              long_name: 'Downers Grove',
              short_name: 'Downers Grove',
              types: [
                'locality',
                'political'
              ]
            },
            {
              long_name: 'York Township',
              short_name: 'York Township',
              types: [
                'administrative_area_level_3',
                'political'
              ]
            },
            {
              long_name: 'DuPage County',
              short_name: 'Dupage County',
              types: [
                'administrative_area_level_2',
                'political'
              ]
            },
            {
              long_name: 'Illinois',
              short_name: 'IL',
              types: [
                'administrative_area_level_1',
                'political'
              ]
            },
            {
              long_name: 'United States',
              short_name: 'US',
              types: [
                'country',
                'political'
              ]
            },
            {
              long_name: '60515',
              short_name: '60515',
              types: [
                'postal_code'
              ]
            }
          ],
          formatted_address: '3815 Highland Ave, Downers Grove, IL 60515, USA',
          formatted_phone_number: '(630) 275-5900',
          geometry: {
            location: {
              lat: 41.8176708,
              lng: -88.0082896
            },
            viewport: {
              northeast: {
                lat: 41.8192425302915,
                lng: -88.0070495697085
              },
              southwest: {
                lat: 41.8165445697085,
                lng: -88.0097475302915
              }
            }
          },
          international_phone_number: '+1 630-275-5900',
          name: 'Advocate Good Samaritan Hospital',
          opening_hours: {
            open_now: true,
            periods: [
              {
                close: null,
                open: {
                  day: 0,
                  time: '0000'
                }
              }
            ],
            weekday_text: [
              'Monday: Open 24 hours',
              'Tuesday: Open 24 hours',
              'Wednesday: Open 24 hours',
              'Thursday: Open 24 hours',
              'Friday: Open 24 hours',
              'Saturday: Open 24 hours',
              'Sunday: Open 24 hours'
            ]
          },
          permanently_closed: false,
          place_id: 'ChIJH0a4ZQFODogRxuiuOHTiJ1M',
          website: 'http://advocatehealth.com/gsam/'
        }
      },
      hour: null,
      permanentlyClosed: false,
      financeEmail: null,
      isAlwaysOpen: true,
      isOpen: true,
      isOpenBit: 1,
      hasHours: true,
      todaysHours: 'Friday: Open 24 hours'
    }
  }
]
